<template>
  <div class="popover" ref="popover">
      <div ref="contentWrapper" :class="positionClass" id="contentWrapper" class="contentWrapper" v-if="flag" >
          <slot name="content"></slot>
      </div>
      <span ref="triggerWrapper">
          <slot></slot>
      </span>
  </div>
</template>

<script>
export default {
    name: 'g-popover',
    data() {
        return {
            flag: false
        }
    },
    props: {
        position: {
            type: String,
            default: 'top',
            validator(value) {
                return ['top', 'bottom', 'left', 'right'].indexOf(value) >= 0
            }
        },
        trigger: {
            type: String,
            default: 'click',
            validator(value) {
                return ['click', 'hover'].indexOf(value) >=0
            }
        }
    },
    mounted() {
        if(this.trigger === 'click') {
            this.$refs.popover.addEventListener(this.openEvent,this.onClick)
        }else {
            this.$refs.popover.addEventListener('mouseenter',this.doOpen)
            this.$refs.popover.addEventListener('mouseleave',this.doClose)
        }
    },
    beforeDestroy() {
        if(this.trigger === 'click') {
            this.$refs.popover.removeEventListener(this.openEvent,this.onClick)
        }else {
            this.$refs.popover.removeEventListener('mouseenter',this.doOpen)
            this.$refs.popover.removeEventListener('mouseleave',this.doClose)
        }
    },
    computed: {
        positionClass() {
            return {
                [`${this.position}Position`]:this.position
            }
        },
        openEvent() {
            return this.trigger === 'click' ? 'click' : 'mouseenter'
        },
        closeEvent() {
            return this.trigger === 'click' ? 'click' : 'mouseleave'
        }
    },
    methods: {
        getStyleObj(key,width, height, top, left) {
            return {
                'top': {
                    left: `${left+window.scrollX}px`,
                    top: `${top+window.scrollY}px`
                },
                'bottom': {
                    left: `${left+window.scrollX}px`,
                    top: `${top+window.scrollY+height}px`
                },
                'left': {
                    left: `${left+window.scrollX}px`,
                    top: `${top+window.scrollY+height/2}px`
                },
                'right': {
                    left: `${left+window.scrollX+width}px`,
                    top: `${top+window.scrollY+height/2}px`
                },
            }[key]
        },
        setPosition() {
            document.body.appendChild(this.$refs.contentWrapper)
            const { width, height, top, left } = this.$refs.triggerWrapper.getBoundingClientRect()
            const contentWrapperStyle = this.$refs.contentWrapper.style
            const obj = this.getStyleObj(this.position, width, height, top, left )
            contentWrapperStyle.left = obj.left
            contentWrapperStyle.top = obj.top
        },
        eventHandler(e) {
            if(!this.$refs.triggerWrapper.contains(e.target) && (this.$refs.contentWrapper && !this.$refs.contentWrapper.contains(e.target)) ){
                this.doClose()
            }
        },
        listenToDocument() {
            document.addEventListener('click', this.eventHandler)
        },
        doOpen() {
            this.flag = true
            this.$nextTick(()=> {
                this.setPosition()
                this.listenToDocument()
            })
        },
        doClose() {
            this.flag = false
            document.removeEventListener('click', this.eventHandler)
        },
        onClick(event) {
            if(this.$refs.triggerWrapper.contains(event.target)) {
                this.flag = !this.flag
                if (this.flag) {
                    this.doOpen()
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import './var';
.box-shadow {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
}
* {
    box-sizing: border-box;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@mixin weiyuansuTop{
    content:'';
    width:0;
    height:0;
    position:absolute;
    top:100%;
    left:15px;
} 
@mixin weiyuansuBottom{
    content:'';
    width:0;
    height:0;
    position:absolute;
    bottom:100%;
    left:15px;
} 
@mixin weiyuansuRight{
    content:'';
    width:0;
    height:0;
    position:absolute;
    top:50%;
    transform: translateY(-50%);
    right:100%;
}
@mixin weiyuansuLeft{
    content:'';
    width:0;
    height:0;
    position:absolute;
    top:50%;
    transform: translateY(-50%);
    left:100%;
} 
.popover{
    display: inline-flex;
    position: relative;
    
}
.contentWrapper{
    position:absolute;
    border:1px solid $border-color;
    border-radius:4px;
    padding:0.5em 1em;
    max-width:20em;
    word-break: break-all;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,0.5));
    background:#fff;
    &.topPosition{
        margin-top:-10px;
        transform: translateY(-100%);
        &::before{
            @include weiyuansuTop;
            border:10px solid transparent;
            border-top-color: #333;
        }
        &::after{
            @include weiyuansuTop;
            border:10px solid transparent;
            border-top-color: #fff;
            top:calc(100% - 1px);
        }
    }
    &.bottomPosition{
        margin-top:10px;
        &::before{
        @include weiyuansuBottom;
        border:10px solid transparent;
        border-bottom-color: #333;
        }
        &::after{
            @include weiyuansuBottom;
            border:10px solid transparent;
            border-bottom-color: #fff;
            bottom:calc(100% - 1px);
        }
    }
    &.rightPosition{
        transform: translateY(-50%);
        margin-left:10px;
        &::before{
        @include weiyuansuRight;
        border:10px solid transparent;
        border-right-color: #333;
        }
        &::after{
            @include weiyuansuRight;
            border:10px solid transparent;
            border-right-color: #fff;
            right:calc(100% - 1px);
        }
    }
    &.leftPosition{
        transform: translate(-100%,-50%);
        margin-left:-10px;
        &::before{
        @include weiyuansuLeft;
        border:10px solid transparent;
        border-left-color: #333;
        }
        &::after{
            @include weiyuansuLeft;
            border:10px solid transparent;
            border-left-color: #fff;
            left:calc(100% - 1px);
        }
    }
}
</style>